
import { Vue } from "vue-class-component";

export default class WarningTriangleOutline extends Vue {}
